import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  contact: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the contact
export const fetchContact = createAsyncThunk(
  "fetchContact/contact",
  async ({ enqueueSnackbar, limit = 10, page = 0, search }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`contact-us`, {
        params: {
          limit,
          page: page + 1,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.meta.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create the contact
export const createContact = createAsyncThunk(
  "createContact/contact",
  async ({ enqueueSnackbar, data, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`contact`, data);
      return {
        data: response.data.data,
        // meta: {
        //   total: response.data.data.length,
        // },
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update the contact
export const updateContact = createAsyncThunk(
  "updateContact/contact",
  async ({ enqueueSnackbar, data, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`contact/${id}`, data);
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete team
export const deleteContact = createAsyncThunk(
  "deleteContact/contact",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`contact-us/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const contactlice = createSlice({
  name: "contact",
  initialState,
  extraReducers: (builder) => {
    // TODO: fetch contact
    builder.addCase(fetchContact.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchContact.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.contact = action.payload;
    });

    builder.addCase(fetchContact.rejected, (state, action) => {
      state.fetchLoading = false;
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create contact
    builder.addCase(createContact.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createContact.fulfilled, (state, action) => {
      state.isLoading = false;
      state.contact.data = [action.payload.data, ...state.contact.data];
      state.contact.meta.total = state.contact.meta.total + 1;
      action.payload.enqueueSnackbar("Contact is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createContact.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update contact
    builder.addCase(updateContact.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateContact.fulfilled, (state, action) => {
      state.isLoading = false;
      state.contact.data = state.contact.data.map((contact) => {
        if (contact.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return contact;
        }
      });
      action.payload.enqueueSnackbar("Contact is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateContact.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete contact
    builder.addCase(deleteContact.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteContact.fulfilled, (state, action) => {
      state.isLoading = false;
      state.contact.data = state.contact.data.filter(
        (contact) => contact.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("Contact is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteContact.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });
  },
});

export default contactlice.reducer;
